import { useQueryClient } from "@tanstack/react-query"
import { useState } from "react"
import { toast } from "sonner"
import { refusalOf } from "@/administration/client.ts"
import { ProfilePhoto } from "@/design-system/index.ts"
import { photosQuery, removeOwnPhoto, uploadOwnPhoto } from "./client.ts"
import { describePhotoRefusal } from "./describe.ts"

/** The photo as its Member changes it: uploaded, replaced or removed, each saying how it went. */
export function PhotoChanger({
  person,
  hasPhoto,
}: {
  person: { id: string; name: string }
  hasPhoto: boolean
}) {
  const queryClient = useQueryClient()
  const [busy, setBusy] = useState<"uploading" | "removing">()

  function change(kind: "uploading" | "removing", work: () => Promise<unknown>, saved: string) {
    setBusy(kind)
    void work()
      .then(async () => {
        await queryClient.invalidateQueries({ queryKey: photosQuery.queryKey })
        toast.success(saved)
      })
      .catch((error: unknown) => toast.error(describePhotoRefusal(refusalOf(error))))
      .finally(() => setBusy(undefined))
  }

  return (
    <ProfilePhoto
      person={person}
      hasPhoto={hasPhoto}
      {...(busy && { busy })}
      onChoose={(file) => change("uploading", () => uploadOwnPhoto(file), "Your photo is updated.")}
      onRemove={() => change("removing", removeOwnPhoto, "Your photo is removed.")}
    />
  )
}
